import { getCurrentPentagonArea, tooltipLabelFormatter } from '../helpers';
import { format as unitFormat } from '../../../../../units';

const PointToolTip = ({
  pointTooltip,
  setPointTooltip,
  timezone,
  data,
  series,
  plots,
  pentagonWidth,
  pentagonHeight,
}) => (
  <div
    // Positioning tooltip so it doesn't overflow screen
    ref={(el) => {
      if (!el) return;

      if (window.innerWidth - pointTooltip.position.x - el.getBoundingClientRect().width < 0) {
        setPointTooltip((prev) => ({
          ...prev,
          position: {
            ...prev.position,
            x: pointTooltip.position.x - el.getBoundingClientRect().width - 20,
          },
        }));
      }

      if (window.innerHeight - pointTooltip.position.y - el.getBoundingClientRect().height < 0) {
        setPointTooltip((prev) => ({
          ...prev,
          position: {
            ...prev.position,
            y: pointTooltip.position.y - el.getBoundingClientRect().height - 20,
          },
        }));
      }
    }}
    className="tooltip"
    style={{
      left: pointTooltip.position.x,
      top: pointTooltip.position.y,
    }}
  >
    <table>
      <thead>
        <tr>
          <th colSpan={7}> {tooltipLabelFormatter(pointTooltip.time, timezone)}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Plot</th>
          <th>H2</th>
          <th>C2H2</th>
          <th>C2H4</th>
          <th>CH4</th>
          <th>C2H6</th>
          <th>Area</th>
        </tr>

        {plots.map((plot, i) => {
          const h2Serie = series.filter((serie) => serie.id === plot.h2Id)[0];
          const c2h6Serie = series.filter((serie) => serie.id === plot.c2h6Id)[0];
          const ch4Serie = series.filter((serie) => serie.id === plot.ch4Id)[0];
          const c2h4Serie = series.filter((serie) => serie.id === plot.c2h4Id)[0];
          const c2h2Serie = series.filter((serie) => serie.id === plot.c2h2Id)[0];

          const timeData =
            h2Serie &&
            ch4Serie &&
            c2h6Serie &&
            c2h4Serie &&
            c2h2Serie &&
            data.find((d) => d.time === pointTooltip.time);

          const h2 = timeData[h2Serie.id];
          const ch4 = timeData[ch4Serie.id];
          const c2h6 = timeData[c2h6Serie.id];
          const c2h4 = timeData[c2h4Serie.id];
          const c2h2 = timeData[c2h2Serie.id];

          if (!h2 || !ch4 || !c2h6 || !c2h4 || !c2h2) {
            return null;
          }
          return (
            <tr
              style={{ color: plot.color }}
              key={i}
            >
              <td>{plot.label ? plot.label : 'No label'}</td>
              <td>
                {`${unitFormat(h2Serie.unit, h2, h2Serie.decimals).value} ${
                  unitFormat(h2Serie.unit, h2).unit
                }`}
              </td>
              <td>
                {`${unitFormat(c2h6Serie.unit, c2h6, c2h6Serie.decimals).value} ${
                  unitFormat(c2h6Serie.unit, c2h6).unit
                }`}
              </td>
              <td>
                {`${unitFormat(ch4Serie.unit, ch4, ch4Serie.decimals).value} ${
                  unitFormat(ch4Serie.unit, ch4).unit
                }`}
              </td>
              <td>
                {`${unitFormat(c2h4Serie.unit, c2h4, c2h4Serie.decimals).value} ${
                  unitFormat(c2h4Serie.unit, c2h4).unit
                }`}
              </td>
              <td>
                {`${unitFormat(c2h2Serie.unit, c2h2, c2h2Serie.decimals).value} ${
                  unitFormat(c2h2Serie.unit, c2h2).unit
                }`}
              </td>
              <td>
                {getCurrentPentagonArea({
                  h2,
                  c2h6,
                  ch4,
                  c2h4,
                  c2h2,
                  duvalType: plot.duvalType,
                  pentagonWidth,
                  pentagonHeight,
                })}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default PointToolTip;
